var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingProcess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 570,
    height: 570,
    viewBox: "0 0 570 570",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285 570C127.854 570 0 442.146 0 285C0 127.854 127.854 0 285 0C442.146 0 570 127.854 570 285C570 442.146 442.146 570 285 570ZM285 43.3507C151.758 43.3507 43.3507 151.758 43.3507 285C43.3507 418.242 151.758 526.649 285 526.649C418.242 526.649 526.649 418.242 526.649 285C526.649 151.758 418.242 43.3507 285 43.3507Z",
    fill: "#00E76E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M548 306.675C536.017 306.675 526.325 296.983 526.325 285C526.325 151.758 417.917 43.3507 284.675 43.3507C272.692 43.3507 263 33.6587 263 21.6754C263 9.69198 272.692 0 284.675 0C441.822 0 569.675 127.854 569.675 285C569.675 296.952 559.983 306.675 548 306.675Z",
    fill: "#00E76E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingProcess);
export default __webpack_public_path__ + "static/media/pending_process.00ccf810.svg";
export { ForwardRef as ReactComponent };